import React from "react";
import style from "./Loader.module.css";

function Loader({ IsBLuredBack }) {
  return (
    <div
      style={{ zIndex: "99999999999999999999999999999999999" }}
      className={`main_popup ${style.popupContainer} ${
        IsBLuredBack && style.blurBg
      } `}
    >
      <div className={style.Loader}>
        <li>G</li>
        <li>✋🏻</li>
        <li>P</li>
        <p>Loading...</p>
      </div>
    </div>
  );
}

export default Loader;
